import _ from "lodash";
import ACTIONS from "../actions/KYBTestCacheActions";
import { filterKYBTestcache } from "../../common/utils/FilterFunctions";
import { populateKYBTestcacheFilterOptions } from "../../common/utils/PopulateFilterOptions";
import { setKYBTestcacheFilters } from "../../common/utils/SetFilters";

const initialState = {
    KYBTestcacheData: [],
    filtered_kyb_testcache_records: [],
    kybTestcacheFilterOptions: {
        kybTestcacheCountryOptions: [],
        kybTestcacheDataSourceOptions: [],
    },
    kybTestcacheFilters: {
        kybTestcacheCountryFilter: null,
        kybTestcacheDataSourceFilter: null,
    },
    kyb_testcache_filtered_state: false,
    all_kyb_testcache_records_selected: false,
    some_kyb_testcache_records_selected: false,
    selected_kyb_testcache_records: [],
    kybSourceTypeOptions: [],
}

const KYBTestCacheReducer = (state = initialState, action) => {
    switch (action.type) {

        case ACTIONS.KYBTestcacheActionTypes.ALL_KYB_TESTCACHE_SELECTED: {
            let newState = _.cloneDeep(state);
            newState.all_kyb_testcache_records_selected = !newState.all_kyb_testcache_records_selected;
            const selectedRecordIds = action.payload.recordIds;
            newState.selected_kyb_testcache_records = action.payload.isSelected
                ? [...new Set([...selectedRecordIds])]
                : newState.selected_kyb_testcache_records.filter(selectedRecordId =>
                    !newState.selected_kyb_testcache_records.includes(selectedRecordId));
            return newState
        }

        case ACTIONS.KYBTestcacheActionTypes.SOME_KYB_TESTCACHE_SELECTED: {
            let newState = _.cloneDeep(state);
            const selectedRecordId = [action.payload.recordId];
            newState.selected_kyb_testcache_records = action.payload.isSelected
                ? [...new Set([...newState.selected_kyb_testcache_records, ...selectedRecordId])]
                : newState.selected_kyb_testcache_records.filter(selectedRecordIds =>
                    !selectedRecordId.includes(selectedRecordIds));
            newState.some_kyb_testcache_records_selected = newState.selected_kyb_testcache_records.length > 0 &&
                !newState.all_kyb_testcache_records_selected
            return newState;
        }

        case ACTIONS.apiActionsKYBTestcache.SET_KYB_TESTCACHE_TABLE_DATA: {
            let newState = _.cloneDeep(state);
            newState.KYBTestcacheData = action.payload;
            newState.filtered_kyb_testcache_records = newState.KYBTestcacheData;
            newState.kybTestcacheFilterOptions = populateKYBTestcacheFilterOptions(newState.kybTestcacheFilterOptions,
                newState.KYBTestcacheData);
            newState.kyb_testcache_filtered_state = true;
            return newState;
        }

        case ACTIONS.KYBTestcacheActionTypes.LOAD_KYB_SOURCE_TYPES: {
            let newState = _.cloneDeep(state);
            let sourceTypeAdded = []
            let sourceType = action.payload;
            newState.kybSourceTypeOptions = []; // Reset to avoid duplicates
            sourceType.forEach(st => {
                if (!sourceTypeAdded.includes(st)) {
                    sourceTypeAdded.push(st);
                    newState.kybSourceTypeOptions.push({
                        value: st,
                        label: st
                    });
                }
            });
            return newState;
        }

        case ACTIONS.KYBTestcacheActionTypes.SET_KYB_TESTCACHE_FILTER: {
            let newState = _.cloneDeep(state);
            newState.kybTestcacheFilters = setKYBTestcacheFilters(newState.kybTestcacheFilters,
                action.payload.filterType, action.payload.filterOption);
            return newState;
        }

        case ACTIONS.KYBTestcacheActionTypes.FILTER_KYB_TESTCACHE_RECORDS: {
            let newState = _.cloneDeep(state);
            newState.filtered_kyb_testcache_records = filterKYBTestcache(newState.kybTestcacheFilters, newState.KYBTestcacheData);
            newState.kyb_testcache_filtered_state = true;
            return newState;
        }

        case ACTIONS.KYBTestcacheActionTypes.CLEAR_KYB_TESTCACHE_DETAILS: {
            return initialState;
        }

        default:
            return state;
    }
}

export default KYBTestCacheReducer;

